import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { DataService } from './data.service';
import { CountryFieldRequirementConfig } from '../models/country-field-requirement';

@Injectable({
    providedIn: 'root'
})
export class CountryFieldRequirementService {
    private config$: Observable<CountryFieldRequirementConfig> | null = null;

    constructor(private dataService: DataService) { }

    // Session-cached (shareReplay) so contact-result and verification-result share one HTTP call.
    // Fails "open" (permissive defaults) on any HTTP error so a config-fetch failure never blocks
    // verification.
    getConfig(): Observable<CountryFieldRequirementConfig> {
        if (!this.config$) {
            this.config$ = this.dataService.get<CountryFieldRequirementConfig>(`api/country-field-requirements`)
                .pipe(
                    catchError(() => of({ enforcementEnabled: true, countries: [], citizenshipCodes: [], documentIndicators: [] } as CountryFieldRequirementConfig)),
                    shareReplay(1)
                );
        }

        return this.config$;
    }
}
